import { Container, AppBar, Toolbar, Typography, IconButton, Box, Tabs, Tab, Card, CardHeader, FormControl, RadioGroup, FormControlLabel, Radio, List, ListItem, ListItemAvatar, ListItemText, Divider } from '@mui/material';
import { ArrowBackOutlined, CardMembershipOutlined, Close, CreditCardOutlined, PaymentsOutlined, PixOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CustomTabPanel, a11yProps, toReal, createNewTheme, isJsonString, getBandeira, descriptografar } from '../functions/utils';
import * as React from 'react';

import LinkIcon from '@mui/icons-material/Link';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { ButtonGustio } from '../components/DesignSystem/ButtonGustio';
import { SpacerGustio } from '../components/DesignSystem/SpacerGustio';

function Finalizar() {

  const state = useLocation().state;
  const [loading, setLoading] = useState(false);
  const page = state ? state.page : 'home';
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [messageSnack, setMessageSnack] = useState("");
  const [telefoneAvulso, setTelefoneAvulso] = useState("");
  const [nomeAvulso, setNomeAvulso] = useState("");
  const [taxaEntrega, setTaxaEntrega] = useState("");
  const [tipoEntrega, setTipoEntrega] = useState("");
  const [isMesa, setIsMesa] = useState(false);
  const [carrinho, setCarrinho] = useState([]);
  const [numeroMesa, setNumeroMesa] = useState(false);
  const [formaPagamento, setFormaPagamento] = useState("");
  const [enderecoEntrega, setEnderecoEntrega] = useState("");
  const [enderecoRetirada, setEnderecoRetirada] = useState("");
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [tempoEntrega, setTempoEntrega] = useState("");
  const [valorTotalCarrinho, setValorTotalCarrinho] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [urlBase, setUrlBase] = useState("");

  const navigate = useNavigate();

  const handleBack = () => {
    const numeroMesa = localStorage.getItem('nM');

    if (numeroMesa || valorTotalCarrinho === "0") {
      navigate("/carrinho", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
    } else {
      navigate("/pagamentos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleClose = () => {
    handleCloseLoading(false);
    setOpen(false);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const handleSnack = (title) => {
    setMessageSnack(title)
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleTelefone = (event) => {
    setTelefoneAvulso(event.target.value);
  };

  const handleNome = (event) => {
    setNomeAvulso(event.target.value);
  };

  const handleFinalizar = async (isAvulso) => {
    const status = localStorage.getItem("sTA")
    if (status.includes("Fechado")) {
      handleSnack("O estabelecimento não está aberto no momento!");
      return;
    }
    // handleOpenLoading();
    let detalhes = "", adicionaissrt = "", mensagemWhats
    const opcaoEntrega = tipoEntrega === 1 ? `*Endereço para entrega:*
*Retirada*` : `*Opção de entrega:*
*${enderecoEntrega}*`

    // const mainId = localStorage.getItem('Md');
    const mainName = localStorage.getItem('Mn');
    const currentCarrinho = localStorage.getItem('crU');
    const idusuario = localStorage.getItem('iUsr');
    const urlMessage = localStorage.getItem('UMs');
    let json
    for (const produto of JSON.parse(atob(currentCarrinho))) {
      let c = 0
      for (const adicional of produto.adicionais) {
        if (c === 0) {
          adicionaissrt += `✅ Adicionais:
`
        }
        adicionaissrt += adicional.categoriaOpcional + " " + adicional.nomeOpcional.toLowerCase() + ": + " + adicional.quantidadeOpcional + "x R$" + adicional.valorOpcional + `
`
        c++;
      }
      const unitario = (parseFloat(produto.valorTotal.replace(".", "").replace(",", ".")) / parseInt(produto.quantidade)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
      const subTotal = (parseFloat(produto.valorTotal.replace(".", "").replace(",", "."))).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
      detalhes = detalhes + "➡ " + produto.nome + `
Quantidade: ` + produto.quantidade + `
Valor Unitário: ${produto.valorOriginal === "0,00" ? `A Consultar` : `*R$ ${produto.valorOriginal !== produto.valorTotal && parseFloat(produto.valorOriginal.replace(".", "").replace(",", ".")) - parseFloat(produto.valorTotal.replace(".", "").replace(",", ".")) > 0 ? `${produto.valorOriginal}*` : `${unitario}`}*`}${produto.valorOriginal !== produto.valorTotal && parseFloat(produto.valorOriginal.replace(".", "").replace(",", ".")) - parseFloat(produto.valorTotal.replace(".", "").replace(",", ".")) > 0 ? `
Desconto: *R$ ${toReal(parseFloat(produto.valorOriginal.replace(".", "").replace(",", ".")) - parseFloat(produto.valorTotal.replace(".", "").replace(",", ".")))}*` : ``}
Subtotal: ${subTotal === "0,00" ? `A Consultar` : `*R$ ` + subTotal + `*`}
` + adicionaissrt + "Observações no item: " + produto.observacoes + `
`
      adicionaissrt = ""
    }

    if (parseInt(idusuario) > 0 && !isMesa) {
      const nomecliente = localStorage.getItem('nmUsr');
      const telefone = localStorage.getItem('tUsr');

      const mensagem = getMessage(nomecliente, telefone, detalhes, formaPagamento, opcaoEntrega)
      mensagemWhats = getMessage(nomecliente, telefone, detalhes, formaPagamento, opcaoEntrega)
      mensagemWhats = mensagemWhats.replaceAll('$tipomensagem$', "📍 *PEDIDO NOVO - #IDPEDIDO#*");
      mensagemWhats = mensagemWhats.replaceAll('$pedido$', `*Nome: ${nomecliente}*\n*Celular: ${telefone}*`);
      mensagemWhats = mensagemWhats.replaceAll('$faleconosco$', "");
      let bloquearCarrinho = localStorage.getItem('bCrt');
      json = {
        idestabelecimentos: localStorage.getItem("Md"),
        nomeestabelecimento: mainName,
        idusuarios: idusuario,
        nomecliente: nomecliente,
        detalhes: currentCarrinho,
        taxa: taxaEntrega ? taxaEntrega : "",
        valor: bloquearCarrinho ? localStorage.getItem('vPt') : valorTotalCarrinho,
        formapagamento: formaPagamento.includes("dinheiro") ? `${localStorage.getItem('sT') ? `Dinheiro - Troco para R$ ${toReal(localStorage.getItem('sT'))}` : "Dinheiro - Sem troco"}` : (formaPagamento.includes("{") ? formaPagamento : formaPagamento.toUpperCase()),
        endereco: tipoEntrega === 1 ? "Retirada" : enderecoEntrega,
        telefone: telefone.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", ""),
        numero: urlMessage.replaceAll("https://wa.me/", "").replaceAll("?text=", ""),
        mensagem: mensagem,
      }
    } else {
      let isValid = false
      if (!isAvulso) {
        if (isMesa) {
          await getPedidoMesa().then(resultado => {
            if (!resultado) {
              setOpen(true)
              return
            } else {
              isValid = true
            }
          });
        } else {
          setOpen(true)
          return
        }
      }

      if (!nomeAvulso && !isValid) {
        handleSnack("Por favor, você deve preencher um nome, por exemplo (John Doe).");
        return
      }

      if ((!telefoneAvulso || telefoneAvulso.length < 11) && !isValid) {
        handleSnack("Por favor, você deve preencher um telefone válido com DDD, por exemplo (11912341234).");
        return
      }

      const mensagem = getMessage(nomeAvulso, telefoneAvulso, detalhes, formaPagamento, opcaoEntrega, isMesa, numeroMesa)
      mensagemWhats = getMessage(nomeAvulso, telefoneAvulso, detalhes, formaPagamento, opcaoEntrega, isMesa, numeroMesa)
      mensagemWhats = mensagemWhats.replaceAll('$tipomensagem$', "📍 *PEDIDO NOVO - #IDPEDIDO#*");
      mensagemWhats = mensagemWhats.replaceAll('$pedido$', `*Nome: ${nomeAvulso}*\n*Celular: ${telefoneAvulso}*`);
      mensagemWhats = mensagemWhats.replaceAll('$faleconosco$', "");
      handleClose();
      handleOpenLoading();

      let bloquearCarrinho = localStorage.getItem('bCrt');
      if (isMesa) {
        json = {
          idestabelecimentos: localStorage.getItem("Md"),
          nomeestabelecimento: mainName,
          idusuarios: "0",
          nomecliente: `mesa--${numeroMesa}--${nomeAvulso}`,
          detalhes: currentCarrinho,
          taxa: "",
          valor: valorTotalCarrinho,
          formapagamento: "",
          endereco: "Retirada",
          telefone: telefoneAvulso,
          numero: urlMessage.replaceAll("https://wa.me/", "").replaceAll("?text=", ""),
          mensagem: mensagem
        }
      } else {
        json = {
          idestabelecimentos: localStorage.getItem("Md"),
          nomeestabelecimento: mainName,
          idusuarios: "0",
          nomecliente: nomeAvulso,
          detalhes: currentCarrinho,
          taxa: taxaEntrega ? taxaEntrega : "",
          valor: bloquearCarrinho ? localStorage.getItem('vPt') : valorTotalCarrinho,
          formapagamento: formaPagamento.includes("dinheiro") ? `${localStorage.getItem('sT') ? `Dinheiro - Troco para R$ ${toReal(localStorage.getItem('sT'))}` : "Dinheiro - Sem troco"}` : formaPagamento.toUpperCase(),
          endereco: tipoEntrega === 1 ? "Retirada" : enderecoEntrega,
          telefone: telefoneAvulso,
          numero: urlMessage.replaceAll("https://wa.me/", "").replaceAll("?text=", ""),
          mensagem: mensagem
        }
      }
    }
    json.email = localStorage.getItem('emUsr')
    json.irc = localStorage.getItem('iRc');

    const url = localStorage.getItem('UBs');
    let bloquearCarrinho = localStorage.getItem('bCrt');

    let endpoint = "cadastro-pedido.php";
    if (bloquearCarrinho) {
      endpoint = "cadastro-pedido-pontos.php"
    }
    axios.post(`${url}/${endpoint}`, json)
      .then(response => {
        response = response.data
        if (!response) {
          handleSnack("Não foi possivel confirmar seu pedido, verifique sua conexão e tente novamente.")
          return;
        }
        if (response.resposta === "pontos insuficientes") {
          handleSnack("Você não possui pontos suficientes para realizar o resgate!")
          return;
        }
        if (response.resposta === "sucesso") {
          mensagemWhats = mensagemWhats.replaceAll(`
`, "%0A")
          const urlWhats = (`${urlMessage}${mensagemWhats}`).replaceAll("#IDPEDIDO#", response.datapedido);
          window.open(urlWhats, '_blank');
          let pontos = parseInt(localStorage.getItem('pUsr')) - parseInt(localStorage.getItem('vPt'));
          if (bloquearCarrinho) {
            localStorage.setItem('pUsr', pontos);
          }
          localStorage.removeItem('eEA');
          localStorage.removeItem('nmEA');
          localStorage.removeItem('iEA');
          localStorage.removeItem('txE');
          localStorage.removeItem('fmP');
          localStorage.removeItem('tE');
          localStorage.removeItem('vlT');
          localStorage.removeItem('sT');
          localStorage.removeItem('crU');
          localStorage.removeItem('bCrt');
          localStorage.removeItem('vPt');
          navigate(`/finalizado/${response.idpedido}`, { replace: true, state: { colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
          return;
        }

        const msgRetorno = response.msg ?? "Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."
        handleSnack(msgRetorno)
      })
      .catch(error => {
        const msg = error.response.data.userMessage ?? "Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.";
        handleSnack(msg)
      });
  };

  const getMessage = (nome, telefone, detalhes, formapagamento, opcaoentrega, isMesa, numeroMesa) => {
    let detalhesAdicionais
    if (formapagamento && formapagamento.includes("{")) {
      formapagamento = "Pago pelo APP";
    }

    if (isMesa) {
      detalhesAdicionais = `Número da mesa: ${numeroMesa}`
    } else {
      detalhesAdicionais = `Forma de pagamento: ${formapagamento.toUpperCase()}
${localStorage.getItem('sT') ? `Troco para R$ ${toReal(localStorage.getItem('sT'))}` : "Sem troco"}
${opcaoentrega}`
    }

    return `$tipomensagem$

$pedido$
🛒 Os itens escolhidos são:

${detalhes}
Taxa de entrega: ${taxaEntrega ? `${taxaEntrega === "combinar" ? `A Combinar` : `R$ ${taxaEntrega}`}` : "-"}
Valor total do pedido: ${valorTotalCarrinho === 0 ? `A Consultar` : `R$ ${valorTotalCarrinho}`}
${detalhesAdicionais}

$faleconosco$`
  }

  const handleChange = (event, newValue) => {
    setTipoEntrega(newValue);
    setButtonEnabled(false);
    if (newValue === 0 && (!enderecoEntrega || enderecoEntrega === "-")) {
      setEnderecoEntrega("-");
      setTaxaEntrega("-");
      setButtonEnabled(true);
      return;
    }
    if (!taxaEntrega && newValue === 0) {
      handleSnack("Desculpe, o estabelecimento não trabalha com entregas no endereço indicado.");
      setButtonEnabled(true);
      return
    }
    if (taxaEntrega) {
      if (parseFloat(taxaEntrega.replaceAll(",", ".")) > 0 && newValue === 0) {
        setValorTotalCarrinho(toReal(parseFloat(localStorage.getItem('vlT').replaceAll(".", "").replaceAll(",", '.')) + parseFloat(taxaEntrega.replaceAll(".", "").replaceAll(",", '.'))))
      } else {
        setButtonEnabled(false);
        setValorTotalCarrinho(toReal(parseFloat(localStorage.getItem('vlT').replaceAll(".", "").replaceAll(",", '.'))))
      }
    }
    if (newValue === 1) {
      setButtonEnabled(false);
      setValorTotalCarrinho(toReal(parseFloat(localStorage.getItem('vlT').replaceAll(".", "").replaceAll(",", '.'))))
    }
  };

  const getPedidoMesa = () => {
    const mesa = localStorage.getItem('nM');
    const urlBase = localStorage.getItem('UBs');
    return axios.get(`${urlBase}/pedido-mesa.php?numeromesa=${mesa}`)
      .then(response => {
        if (!response) {
          return false
        }
        return response.data[0].nomecliente
      })
      .catch(error => {
        console.log("ERRO CÓDIGO 14")
        return null;
      });
  }

  const handleEndereco = (event) => {
    navigate("/enderecos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
  };

  const handlePagamento = (event) => {
    let bloquearCarrinho = localStorage.getItem('bCrt');
    if (bloquearCarrinho) {
      handleSnack("Você não pode alterar a forma de pagamento enquanto faz um resgate!")
      return;
    }
    navigate("/pagamentos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
  };

  const updateCart = () => {
    let currentCarrinho = localStorage.getItem('crU');
    if (currentCarrinho) {
      currentCarrinho = JSON.parse(atob(currentCarrinho))
      let valorTotal = 0
      setCarrinho(currentCarrinho)
      for (const produto of currentCarrinho) {
        valorTotal += parseFloat(produto.valorTotal.replaceAll(".", "").replaceAll(",", '.'))
      }
      let bloquearCarrinho = localStorage.getItem('bCrt');
      if (valorTotal === 0 && !bloquearCarrinho && localStorage.getItem("vPt")) {
        localStorage.removeItem('crU');
        handleBack()
      }
      localStorage.setItem('vlT', toReal(valorTotal));
      setValorTotalCarrinho(toReal(valorTotal))
    }
  }

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store-${localStorage.getItem("Md")}.png?${new Date().getTime()}`;

    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      setIsMesa(true)
      setNumeroMesa(numeroMesa)
      updateCart();
    }

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    const entrega = localStorage.getItem('tE');
    setTipoEntrega(parseInt(entrega))
    let endereco = localStorage.getItem('eEA');
    if (endereco && endereco.endsWith(", ")) {
      endereco = endereco.slice(0, -2);
    }
    setEnderecoEntrega(endereco)
    const pagamento = localStorage.getItem('fmP');
    setFormaPagamento(pagamento)
    const retirada = localStorage.getItem('eR');
    setEnderecoRetirada(retirada)
    const timeDelivery = localStorage.getItem('tD');
    const arrTime = timeDelivery.split("(")
    setTempoEntrega(arrTime[1].replaceAll(")", ""))
    const taxaEntrega = localStorage.getItem('txE');
    taxaEntrega === "0,00" ? setTaxaEntrega("Grátis") : setTaxaEntrega(taxaEntrega)
    const valorTotal = localStorage.getItem('vlT');
    if (taxaEntrega) {
      if (parseFloat(taxaEntrega.replaceAll(",", ".")) > 0 && entrega === "0") {
        setValorTotalCarrinho(toReal(parseFloat(valorTotal.replaceAll(".", "").replaceAll(",", '.')) + parseFloat(taxaEntrega.replaceAll(".", "").replaceAll(",", '.'))))
      } else {
        setButtonEnabled(false);
        setValorTotalCarrinho(valorTotal)
      }
    } else {
      setValorTotalCarrinho(valorTotal)
    }

    const url = localStorage.getItem('UBs');
    setUrlBase(url);

    handleCloseLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTaxa = (taxa) => {
    if (!taxa) {
      return <>-</>
    }
    if (taxa === "-") {
      return <>-</>
    }
    if (taxa === "Grátis") {
      return <>Grátis</>
    }
    if (taxa === "combinar") {
      return <>A Combinar</>
    }
    return <>R$ {taxa}</>
  }

  const getTitleForPaymentMethod = (paymentMethod) => {
    let json = isJsonString(paymentMethod) ? JSON.parse(paymentMethod) : paymentMethod

    if (json.ID_forma_pagamento && json.NR_CT) {
      return <Typography style={{ fontSize: 11, color: "#777" }}>{descriptografar(json.NR_CT)}<br /><b style={{ fontSize: 14, color: "#222" }}>{json.NM_USR}</b></Typography>
    }
    return paymentMethod.toUpperCase();
  }

  const getIconForPaymentMethod = (paymentMethod) => {
    if (!paymentMethod) {
      return <PaymentsOutlined style={{ color: '#464545' }} />;
    }
    if (paymentMethod.includes("Dinheiro")) {
      return <PaymentsOutlined style={{ color: '#464545' }} />;
    }
    let json = isJsonString(paymentMethod) ? JSON.parse(paymentMethod) : paymentMethod
    if (json.ID_forma_pagamento) {
      return <img alt="bandeira" src={`${localStorage.getItem('UBs').replaceAll("/api", "")}/imagens/${getBandeira(json.NR_CT)}.png`} style={{ width: 40 }} />
    }
    paymentMethod = paymentMethod.toUpperCase()
    switch (paymentMethod) {
      case 'PIX':
        return <PixOutlined style={{ color: '#464545' }} />;
      case 'MASTERCARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'VISA':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'ELO':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'AMERICAN EXPRESS':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'BANRI COMPRAS':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'VERDCARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'HIPERCARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'DINNERS CLUB':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'AURA':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'CREDICARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'SOROCRED':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'PAN':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'ALELO':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'SODEXO':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'TICKET':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'VR BENEFICIOS':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'FLASH':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'GREENCARD':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'VB':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'IFOOD ALIMENTAÇÃO':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'LINK DE PAGAMENTO':
        return <LinkIcon style={{ color: '#464545' }} />;
      case 'PONTOS':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      default:
        return <PaymentsOutlined style={{ color: '#464545' }} />;
    }
  };

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>
        <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
              <ArrowBackOutlined />
            </IconButton>
            Finalizar
          </Toolbar>
        </AppBar>

        <LoadingComponent open={loading} />

        <Snackbar
          open={openSnack}
          autoHideDuration={10000}
          onClose={handleCloseSnack}
          message={messageSnack}
          action={<Close fontSize="small" onClick={handleCloseSnack} />}
        />
        <SpacerGustio height={70} />

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              handleFinalizar(true);
            },
          }}
        >
          <DialogTitle>Finalizar pedido:</DialogTitle>

          <DialogContent>
            <DialogContentText>
              Para finalizar o seu pedido, por favor digite seu nome e telefone abaixo:
            </DialogContentText>
            <TextField
              margin="dense"
              label="Nome"
              value={nomeAvulso}
              onChange={handleNome}
              placeholder="Nome"
              fullWidth
            />
            <TextField
              margin="dense"
              label="Telefone com DDD"
              value={telefoneAvulso}
              onChange={handleTelefone}
              placeholder="Telefone (só números)"
              fullWidth
            />
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2, display: "flex" }}>
            <ButtonGustio onClick={handleClose}>Voltar</ButtonGustio>
            <SpacerGustio width={10} />
            <ButtonGustio type="submit">Continuar</ButtonGustio>
          </DialogActions>
        </Dialog>

        {isMesa && (
          <Typography style={{ color: "#1B1B1B", fontSize: "16px", fontWeight: "bold" }}>
            Mesa: {numeroMesa}
            <SpacerGustio height={15} />
            <b style={{ fontSize: "14px", color: "#999" }}>Resumo do pedido:</b>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              {carrinho.map((produto) => (
                <>
                  <ListItem disableGutters alignItems="flex-start">
                    <ListItemAvatar>
                      <img alt="produto" src={`${urlBase.replaceAll("/api", "")}/imagens-produtos/${produto.id}_0.png?${new Date().getTime()}`} style={{ borderRadius: "4px", height: "56px", width: "56px" }} onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "https://gustio.com.br/imagens/placeholder.png";
                      }} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={produto.nome}
                      primaryTypographyProps={{ fontSize: "16px", color: "#1B1B1B", fontWeight: "bold", paddingLeft: "16px" }}
                      secondary={
                        <React.Fragment>
                          <Typography sx={{ fontSize: "14px", color: "#999", paddingLeft: "16px" }}>
                            {produto.descricao}
                            {(produto.adicionais).map((adicional) => (
                              <>
                                <b style={{ fontSize: "12px" }}><br />+ {adicional.quantidadeOpcional}x {adicional.nomeOpcional}</b>
                              </>
                            ))}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider />
                </>
              ))}
            </List>

          </Typography>
        )}

        {!isMesa && (
          <Box sx={{ width: '100%' }}>
            <Tabs value={tipoEntrega} onChange={handleChange} variant="fullWidth" >
              <Tab label="Entrega" {...a11yProps(0)} style={{ textTransform: "none", borderBottom: "1px solid #CCC" }} />
              <Tab label="Retirada" {...a11yProps(1)} style={{ textTransform: "none", borderBottom: "1px solid #CCC" }} />
            </Tabs>
            <CustomTabPanel value={tipoEntrega} index={0}>
              <Typography style={{ color: "#1B1B1B", fontSize: "16px", fontWeight: "bold", marginLeft: "-22px", marginRight: "-22px" }}>
                Entregar em:
                <SpacerGustio height={10} />
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                  <CardHeader
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    avatar={
                      <FormControl value={enderecoEntrega}>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                        >
                          <FormControlLabel value="2" checked control={<Radio />} />
                        </RadioGroup>
                      </FormControl>
                    }
                    action={
                      <ButtonGustio variant="text" aria-label="settings" onClick={handleEndereco}>
                        Alterar
                      </ButtonGustio>
                    }
                    title="Casa"
                    titleTypographyProps={{ fontSize: "12px", fontWeight: "500", marginLeft: "-20px", color: "#999" }}
                    subheader={enderecoEntrega}
                    subheaderTypographyProps={{ fontSize: "14px", fontWeight: "bold", marginLeft: "-20px", color: "#1B1B1B" }}
                  />
                </Card>
                <SpacerGustio height={12} />
                Hoje, {tempoEntrega}
                <SpacerGustio height={10} />
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                  <CardHeader
                    title="Taxa de entrega"
                    titleTypographyProps={{ fontSize: "12px", fontWeight: "500", color: "#999" }}
                    subheader={handleTaxa(taxaEntrega)}
                    subheaderTypographyProps={{ fontSize: "12px", fontWeight: "bold", color: "#1B1B1B" }}
                  />
                </Card>

                <SpacerGustio height={12} />
                Forma de pagamento
                <SpacerGustio height={10} />
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                  <CardHeader
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    avatar={getIconForPaymentMethod(formaPagamento)}
                    action={
                      <ButtonGustio variant="text" aria-label="settings" onClick={handlePagamento}>
                        Alterar
                      </ButtonGustio>
                    }
                    title={getTitleForPaymentMethod(formaPagamento)}
                    titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
                  />
                </Card>
              </Typography>
            </CustomTabPanel>
            <CustomTabPanel value={tipoEntrega} index={1}>
              <Typography style={{ color: "#1B1B1B", fontSize: "16px", fontWeight: "bold", marginLeft: "-22px", marginRight: "-22px" }}>
                Retirar em:
                <SpacerGustio height={10} />
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                  <CardHeader
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    title="Local"
                    titleTypographyProps={{ fontSize: "12px", fontWeight: "500", color: "#999" }}
                    subheader={enderecoRetirada}
                    subheaderTypographyProps={{ fontSize: "14px", fontWeight: "bold", color: "#1B1B1B" }}
                  />
                </Card>
                <SpacerGustio height={12} />
                Hoje, {tempoEntrega}
                <SpacerGustio height={10} />
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                  <CardHeader
                    title="Taxa de entrega"
                    titleTypographyProps={{ fontSize: "12px", fontWeight: "500", color: "#999" }}
                    subheader="-"
                    subheaderTypographyProps={{ fontSize: "12px", fontWeight: "bold", color: "#1B1B1B" }}
                  />
                </Card>

                <SpacerGustio height={12} />
                Forma de pagamento
                <SpacerGustio height={10} />
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                  <CardHeader
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    avatar={getIconForPaymentMethod(formaPagamento)}
                    action={
                      <ButtonGustio variant="text" aria-label="settings" onClick={handlePagamento}>
                        Alterar
                      </ButtonGustio>
                    }
                    title={getTitleForPaymentMethod(formaPagamento)}
                    titleTypographyProps={{ fontSize: "14px", fontWeight: "600", color: "#1B1B1B" }}
                  />
                </Card>
              </Typography>
            </CustomTabPanel>
          </Box>
        )}

        <Box style={{ borderTop: `solid 1px rgba(${colorPrimary})`, position: "fixed", bottom: "0", right: "0", left: "0", backgroundColor: "white", padding: "16px 16px 16px 16px" }}>
          <Typography style={{ float: "left", fontSize: "14px", fontWeight: "bold", paddingLeft: "16px" }}>
            {!isMesa ? (
              <>
                Total com entrega
              </>
            ) : (
              <>
                Total
              </>
            )}
          </Typography>
          <Typography style={{ float: "right", fontSize: "16px", fontWeight: "bold", color: `rgba(${colorPrimary})` }}>
            {valorTotalCarrinho === "0" && localStorage.getItem("vPt") ? (
              <>
                Resgate
              </>
            ) : (
              <>
                {valorTotalCarrinho === "0" ?
                  <>A Consultar</>
                  :
                  <> R$ {valorTotalCarrinho} </>
                }
              </>
            )}
          </Typography>
          <SpacerGustio height={35} />
          <ButtonGustio disabled={buttonEnabled} onClick={() => handleFinalizar(false)}>
            Finalizar pedido
          </ButtonGustio>
        </Box>
        <SpacerGustio height={150} />

      </Container>
    </ThemeProvider>
  );
}

export default Finalizar;